"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSerialRequestT = exports.OpenSerialRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class OpenSerialRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsOpenSerialRequest(bb, obj) {
        return (obj || new OpenSerialRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsOpenSerialRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new OpenSerialRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    /**
     * Automatically pick the first serial device available
     */
    auto() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    port(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startOpenSerialRequest(builder) {
        builder.startObject(2);
    }
    static addAuto(builder, auto) {
        builder.addFieldInt8(0, +auto, +false);
    }
    static addPort(builder, portOffset) {
        builder.addFieldOffset(1, portOffset, 0);
    }
    static endOpenSerialRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createOpenSerialRequest(builder, auto, portOffset) {
        OpenSerialRequest.startOpenSerialRequest(builder);
        OpenSerialRequest.addAuto(builder, auto);
        OpenSerialRequest.addPort(builder, portOffset);
        return OpenSerialRequest.endOpenSerialRequest(builder);
    }
    unpack() {
        return new OpenSerialRequestT(this.auto(), this.port());
    }
    unpackTo(_o) {
        _o.auto = this.auto();
        _o.port = this.port();
    }
}
exports.OpenSerialRequest = OpenSerialRequest;
class OpenSerialRequestT {
    constructor(auto = false, port = null) {
        this.auto = auto;
        this.port = port;
    }
    pack(builder) {
        const port = (this.port !== null ? builder.createString(this.port) : 0);
        return OpenSerialRequest.createOpenSerialRequest(builder, this.auto, port);
    }
}
exports.OpenSerialRequestT = OpenSerialRequestT;
